import { useCallback, useMemo, useRef, useState } from 'react';

import { useOutsideClick } from '@vimeo/bokeh';
import { Optional } from '@vimeo/core/types/generic';

export function useControlledPopover(outsideClickHandler?: (event: Event) => void) {
  const triggerRef = useRef(null as Optional<HTMLElement>);
  const contentRef = useRef(null as Optional<HTMLElement>);
  const [isOpen, setIsOpen] = useState(false);

  const onTogglePopover = useCallback(() => setIsOpen((it) => !it), []);

  const onOpenPopover = useCallback(() => setIsOpen(true), []);

  const onClosePopover = useCallback(() => setIsOpen(false), []);

  useOutsideClick({
    enabled: isOpen,
    ref: contentRef,
    handler: useMemo(
      () =>
        outsideClickHandler
          ? outsideClickHandler
          : (event: Event) => {
              if (event.target && triggerRef?.current?.contains(event.target as HTMLElement)) {
                return;
              }

              setIsOpen(false);
            },
      [outsideClickHandler],
    ),
  });

  return {
    isOpen,
    setIsOpen,
    contentRef,
    triggerRef,
    onTogglePopover,
    onOpenPopover,
    onClosePopover,
  };
}
